<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term4">
      <div class="term4-top">
        <div class="term4-top-info">
          联系人:
          <el-input
            v-model="name"
            disabled
            placeholder=""
            @input="handleName(name)"
          />
        </div>
        <div class="term4-top-info">
          联系电话:
          <el-input
            v-model="phone"
            disabled
            placeholder=""
            maxlength="11"
            @input="handleNumber(phone)"
          />
        </div>
        <span @click="handlePre">上一章</span>
        <span @click="handleNext">下一章</span>
        <span @click="handleSave">保存</span>
        <span>获取上年数据</span>
        <span @click="handleClear">清空</span>
      </div>
      <div class="term4-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="code" label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column width="320" prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="uom" label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value5" label="本年数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 53">
                <span class="text-center">{{ person ? person : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 5401">
                <span class="text-center">{{ computer_sum ? computer_sum : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 540101">
                <span class="text-center">{{ computer_teach ? computer_teach : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 5402">
                <span class="text-center">{{ computer_shi ? computer_shi: scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 5403">
                <span class="text-center">{{ computer_sheng ? computer_sheng : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 5502">
                <span class="text-center">{{ media ? media : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 571">
                <span class="text-center">{{ room_sum ? room_sum : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 572">
                <span class="text-center">{{ equip ? equip : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 573">
                <span class="text-center">{{ funds ? funds : scope.row.value5 }}</span>
              </section>
              <section
                v-else-if="scope.row.equipstandardopt.viewOnly[4] == false"
              >
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value5"
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value5, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value5"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[4] == true
                      ? true
                      : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row.value5)"
                  @change="
                    handleValue(
                      scope.row.value5,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
              </section>
              <section v-else>
                <span class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="value6" label="本年面积">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 571">
                <span class="text-center">{{ room_sum_area ? room_sum_area : scope.row.value6 }}</span>
              </section>
              <section v-else>
                <el-input
                  v-if="scope.row.equipstandardopt.viewOnly[5] == false"
                  v-model="scope.row.value6"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[5] == true ? true : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row.value6)"
                  @change="
                    handleValue0(scope.row.value6, scope.$index, scope.row, scope)
                  "
                />
                <span v-else class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  name: 'ComTerm4',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      t: null,
      form: [],
      jsonForm: {},
      other: {
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
        num6: null,
        num7: null
      },
      person: null,
      computer_sum: null,
      computer_teach: null,
      computer_shi: null,
      computer_sheng: null,
      media: null,
      room_sum: null,
      equip: null,
      funds: null,
      room_sum_area: null,
      pushArr: true

    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleOthers()
    if (localStorage.getItem('form5')) {
      this.form = JSON.parse(localStorage.getItem('form5'))
    } else {
      this.form = this.data
    }
  },
  methods: {
    handleOthers() {
      var a = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num1,
        51,
        239,
        '5.1 网络建设情况',
        '',
        '',
        {
          code: 51,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 239,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var b = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num2,
        514,
        243,
        '5.1.4 网络运营商(可多选)',
        '学校接入网络的运营商（1.电信、2.联通、3.移动、4.教科网、5.其他）',
        '',
        {
          code: 514,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 243,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var c = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num3,
        52,
        250,
        '5.2 校园信息化系统建设情况',
        '',
        '',
        {
          code: 52,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 250,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var d = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num4,
        5210,
        260,
        '5.2.10 空间建设情况',
        '',
        '',
        {
          code: 5210,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 260,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var e = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num5,
        54,
        278,
        '5.4 学校计算机配备情况',
        '',
        '',
        {
          code: 54,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 278,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var f = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num6,
        57,
        291,
        '5.7 信息电教功能室装备情况',
        '',
        '',
        {
          code: 57,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 291,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var g = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num7,
        58,
        315,
        '5.8 功能室使用状况',
        '',
        '',
        {
          code: 58,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 315,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''
      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue0(x, y, z, a) {
      var isExit = false
      var obj = {}
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value6 = z.value6
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      var q = this.handleValueModle0(
        57101,
        57102,
        57103,
        57104,
        57105,
        57106,
        57107,
        this.room_sum_area,
        571,
        292,
        '5.7.1 信息电教功能室合计',
        '房间不需要当年新增和减少的面积，面积直接在当年累计中填写，数量需要填写当年增减',
        '个、m²',
        {
          code: 571,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 292,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '57101+57102+57103+57104+57105+57106+57107'
      )
      this.room_sum_area = q
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = null
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = z.value5
      obj.value6 = null
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value5 = z.value5
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      console.log(this.form, 'this.form')

      var a = this.handleValueModle(
        5301,
        5302,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.person,
        53,
        264,
        '5.3 信息技术专任教师及网络管理人员数量',
        '指从事信息技术专任教师及网络管理工作的人员',
        '人',
        {
          code: 53,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 264,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '5301+5302=5303+5304+5305+5306=5307+5308+5309+5310=5311+5312+5313'
      )
      this.person = a
      var b = this.handleValueModle(
        540101,
        540105,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.computer_sum,
        5401,
        279,
        '5.4.1 计算机总数',
        '学校各式计算机（含多媒体内计算机）      ',
        '台',
        {
          code: 5401,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 279,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '540101+540105'
      )
      this.computer_sum = b
      var c = this.handleValueModle(
        540102,
        540103,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.computer_teach,
        540101,
        280,
        '     其中：教学用计算机',
        '教学用计算机包括教师用计算机和学生用计算机',
        '台',
        {
          code: 540101,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 280,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '540102+540103'
      )
      this.computer_teach = c
      var d = this.handleValueModle(
        540102,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.computer_shi,
        5402,
        285,
        '5.4.2 计算机师机比',
        '专任教师配备电脑比列',
        '',
        {
          code: 5402,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 285,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '11301/540102'
      )
      this.computer_shi = d
      var e = this.handleValueModle(
        540103,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.computer_sheng,
        5403,
        286,
        '5.4.3 计算机生机比',
        '',
        '',
        {
          code: 5403,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 286,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '111/540103'
      )
      this.computer_sheng = e
      var f = this.handleValueModle(
        5501,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.media,
        5502,
        289,
        '       普通教室配有多媒体设备占有率 ',
        '',
        '% ',
        {
          code: 5502,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 289,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '5501/19'
      )
      this.media = f
      var g = this.handleValueModle(
        57101,
        57102,
        57103,
        57104,
        57105,
        57106,
        57107,
        0, 0, 0,
        this.room_sum,
        571,
        292,
        '5.7.1 信息电教功能室合计',
        '房间不需要当年新增和减少的面积，面积直接在当年累计中填写，数量需要填写当年增减',
        '个、m²',
        {
          code: 571,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 292,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '57101+57102+57103+57104+57105+57106+57107'
      )
      this.room_sum = g

      var h = this.handleValueModle(
        57201,
        57202,
        57203,
        57204,
        57205,
        57206,
        57207,
        57208,
        57209,
        57210,
        this.equip,
        572,
        300,
        '5.7.2 仪器设备设施情况',
        '指功能室配备的桌、椅、仪器柜和水、电、光、气、安全等设施设备当时购买价格合计',
        '元 ',
        {
          code: 572,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 300,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '57201+57202+57203+57204+57205+57206+57207+57208+57209+57210'
      )
      this.equip = h
      var i = this.handleValueModle(
        57301,
        57302,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.funds,
        573,
        312,
        '5.7.3 当年功能室投入经费合计',
        '',
        '元 ',
        {
          code: 573,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 312,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '57301+57302'
      )
      this.funds = i
      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle0(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value6')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value6')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value6')
      var others = this.arrayLookup(this.form, 'code', code4, 'value6')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value6')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value6')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value6')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1)
      if (value) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = value
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value6 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    handleValueModle(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9,
      code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value5')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value5')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value5')
      var others = this.arrayLookup(this.form, 'code', code4, 'value5')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value5')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value5')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value5')
      var others1 = this.arrayLookup(this.form, 'code', code8, 'value5')
      var pupil2 = this.arrayLookup(this.form, 'code', code9, 'value5')
      var junior2 = this.arrayLookup(this.form, 'code', code10, 'value5')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(others1) +
         Number(pupil2) +
        Number(junior2)
      if (code == 5402) {
        var num2 = localStorage.getItem('11301')
        var value1 = Number(num2) / Number(pupil)
        value = value1.toFixed(2)
      } else if (code == 5403) {
        var num2 = localStorage.getItem('111')
        var value1 = Number(num2) / Number(pupil)
        value = value1.toFixed(2)
      } else if (code == 5502) {
        var num2 = localStorage.getItem('19')
        var value1 = Number(pupil) / Number(num2)
        value = value1.toFixed(3)
      }
      if (
        code == 51 ||
        code == 514 ||
        code == 52 ||
        code == 5210 ||
        code == 54 ||
        code == 57 ||
        code == 58
      ) {
        value = null
      }
      if (
        value ||
        code == 51 ||
        code == 514 ||
        code == 52 ||
        code == 5210 ||
        code == 54 ||
        code == 57 ||
        code == 58
      ) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = value
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value5 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      for (let i = 0; i < this.form.length; i++) {
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = null
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = this.form[i].value5
        const value6 = this.form[i].value6
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form5')
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if ((this.form.length == this.data.length)) {
          this.toJson()
          const obj = {}
          obj.data = JSON.stringify(this.jsonForm)
          api.statistics.submit(obj).then((res) => {
            console.log(res)
            if (JSON.parse(localStorage.getItem('form5')) !== this.form) {
              this.$message.success('已保存成功！')
              localStorage.setItem('form5', JSON.stringify(this.form))
            } else if (JSON.parse(localStorage.getItem('form5')) == this.form) {
              this.$message.error('无修改数据！')
            } else {
              this.$message.success('已保存成功！')
              localStorage.setItem('form5', JSON.stringify(this.form))
            }
          })
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term4 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term4-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
